/**
 * Product Recommend Listener (V2)
 * - addEventListener registration only
 */

import { productRecommendForm } from "./product-recommend-form";

type ProductRecommendHandlerLike = {
    handleRecommendClick(event: MouseEvent, el: HTMLElement): Promise<void>;
};

export class ProductRecommendListener {
    public handler: ProductRecommendHandlerLike;

    public _registered: boolean;

    public constructor(deps: { handler: ProductRecommendHandlerLike }) {
        this.handler = deps.handler;
        this._registered = false;
    }

    public register(): void {
        if (this._registered) return;
        this._registered = true;

        document.addEventListener(
            "click",
            (e) => {
                if (!(e instanceof MouseEvent)) {
                    return;
                }
                const event = e;
                const target = productRecommendForm.getEventTarget(event, Element);
                if (!target) return;

                const crownEl = productRecommendForm.getClosestRecommendButton(target);
                if (crownEl instanceof HTMLElement) {
                    const card = productRecommendForm.getProductCard(crownEl);
                    const canRecommend =
                        crownEl.dataset?.canRecommend === "1" ||
                        (card instanceof HTMLElement && card.dataset?.canRecommend === "1") ||
                        !!productRecommendForm.getRecommendCapabilityHost(crownEl);
                    if (canRecommend) {
                        void this.handler.handleRecommendClick(event, crownEl);
                        return;
                    }
                }
            },
            { capture: true },
        );
    }
}
